import { platformNames } from '../constants/platform-names.contants';

export const hasTwoHomeCarousels = (pharmacy, platform) => {
	if (pharmacy === platformNames.pharol) return true;
	if (platform === platformNames.ecc) return true;
	if (typeof platform === 'string' && platform.includes(platformNames.ecc)) return true;
	return false;
};
